let lastId = 0;

export const getId = (prefix='id') => {
    lastId++;
    return `${prefix}${lastId}`;
}
